import { render, staticRenderFns } from "./DataSourceSelector.vue?vue&type=template&id=1837d737&scoped=true"
import script from "./DataSourceSelector.vue?vue&type=script&lang=js"
export * from "./DataSourceSelector.vue?vue&type=script&lang=js"
import style0 from "./DataSourceSelector.vue?vue&type=style&index=0&id=1837d737&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1837d737",
  null
  
)

export default component.exports